import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { generateUUID } from '@utils/text/string-utils';

export interface LiteratureDocumentListingComponent {
  selectRow: (event, isFromSelectAll: boolean, isSelect: boolean) => void;
}

export interface SelectAllParams extends ICellRendererParams {
  reference?: LiteratureDocumentListingComponent;
}

@Component({
  selector: 'ft-select-cell-renderer',
  templateUrl: './select-cell-renderer.component.html',
  styleUrls: ['./select-cell-renderer.component.scss'],
})
export class SelectCellRendererComponent {
  params: SelectAllParams;
  parentComponent: LiteratureDocumentListingComponent;
  isSelected = false;
  uniqueInputId: string;

  constructor() {
    this.uniqueInputId = 'select-cell_' + generateUUID();
  }

  agInit(params: SelectAllParams) {
    this.params = params;
    this.isSelected = this.params?.data?.literatureData?.isSelected;
    this.parentComponent = params.reference;
  }

  onSelectAllClick(event: PointerEvent) {
    this.parentComponent.selectRow(this.params, false, !this.isSelected);
    // refreshHeader() was removing the properties which we are setting from the stickyheader directive.
    const columnDefs = this.params.api.getColumnDefs();
    this.params.api.setColumnDefs(columnDefs);
    event?.preventDefault();
  }
}
